import axiosIns from '@/api/axios';

export const GET_ALL_DATA = (args) => {
	return axiosIns.get(`/contract?${args}`);
};

export const GET_BY_ID = (id) => {
	return axiosIns.get(`/contract/${id}`);
};

export const GET_FOR_EDIT = (id) => {
	return axiosIns.get(`/contract/${id}?type=edit`);
};

export const GET_HISTORICAL_DETAIL = (id) => {
	return axiosIns.get(`/contract-historical/${id}`);
};

export const ADD_DATA = (args) => {
	return axiosIns.post('/contract', args, {
		headers: {
			'Content-Type': 'multipart/form-data',
		},
	});
};

export const IMPORT_DATA = (args) => {
	return axiosIns.post('/contract/import', args, {
		headers: {
			'Content-Type': 'multipart/form-data',
		},
	});
};

export const UPDATE_DATA = (args) => {
	return axiosIns.put(`/contract/${args.id}`, args.data, {
		headers: {
			'Content-Type': 'multipart/form-data',
		},
	});
};

export const DELETE_DATA = (id) => {
	return axiosIns.delete(`/contract/${id}`);
};

export const IMPORT_CONTRACT = (args) => {
	return axiosIns.post('/import', args);
};

export const GET_VENDOR = () => {
	return axiosIns.get('/vendor');
};

export const GET_PO = () => {
	return axiosIns.get('/ubudget/po-number');
};

export const GET_USER = (args) => {
	return axiosIns.get(`/users-sap?${args}`);
};

export const GET_USER_UENROLL = (args) => {
	return axiosIns.get(`/users-uenroll?${args}`);
};

export const DETAIL = (args) => {
	return axiosIns.get(`/contract/${args}/status`);
};

export const CHANGE_STATUS = (args) => {
	return axiosIns.post(`/contract/${args.id}/status`, args.form, {
		headers: {
			'Content-Type': 'multipart/form-data',
		},
	});
};

export const EXPORT_DATA = (args) => {
	return axiosIns.get(`/contract/export?type=${args.type}`, {
		responseType: 'blob',
	});
};

export const EXPORT_DATA_ID = (id) => {
	return axiosIns.get(`/contract/export?id=${id}`, {
		responseType: 'blob',
	});
};

export const DOWNLOAD_FILE = (args) => {
	return axiosIns.get(`${args}`, {
		responseType: 'blob',
	});
};

// New Version
export const SAVE_CONTRACT = (args) => {
	if (args.type == 'submit') {
		return axiosIns.post('/contract', args.bodys, {
			headers: {
				'Content-Type': 'multipart/form-data',
			},
		});
	} else {
		return axiosIns.post('/contract/draft', args.bodys, {
			headers: {
				'Content-Type': 'multipart/form-data',
			},
		});
	}
};
export const UPDATE_CONTRACT = (args, status, latestStatus) => {
	return axiosIns.post(
		`${args.status == 'existing' ? `/contract/versioning/${args.id}` : `/contract/drafting/${args.id}`}`,
		args.bodys,
		{
			headers: {
				'Content-Type': 'multipart/form-data',
			},
		}
	);
};
// export const SEND_NOTIFICATION = (args) => {
//     return axiosIns.post(`/contract/v2/notification/${args.id}`,{
//         notification: args.body
//     });
// };

export const SEND_NOTIFICATION = (args) => {
	return axiosIns.post(`/contract/notification/${args.id}`, args.body);
};

export const GET_BUDGET_PLAN = () => {
	return axiosIns.get('/budget/plan');
};
export const GET_BUDGET_GL = (id) => {
	return axiosIns.get(`/budget/budget-gl/${id}`);
};
export const GET_BUDGET_TASK = (id) => {
	return axiosIns.get(`/budget/budget-task/${id}`);
};
export const GET_BUDGET_TASK_DETAIL = (body) => {
	return axiosIns.post('/budget/budget-task-detail', body);
};

export const GET_AMANDEMENT_LIST_BY_ID = (id) => {
	return axiosIns.get(`/contract/amandement-list/${id}`);
};

export const GET_CONTRACT_BY_AMANDEMENT = (body) => {
	return axiosIns.post('/contract/amandement', body, {
		headers: {
			'Content-Type': 'application/json',
		},
	});
};

export const UPDATE_AMANDEMENT = (args) => {
	return axiosIns.post(`/contract/amandement/${args.id}`, args.bodys, {
		headers: {
			'Content-Type': 'multipart/form-data',
		},
	});
};

export const GET_LIST_DETAIL_PAYMENT = (id) => {
	return axiosIns.get(`/budget/budget-task/budget-actual/detail-payment/${id}`);
};
